var firebaseConfig = {
    apiKey: "AIzaSyACZQ4T62GEWgKouhp01LLTNdGuv7fgw80",
    authDomain: "app.getitout.io",//"saasmarketingformula.firebaseapp.com",
    databaseURL: "https://saasmarketingformula.firebaseio.com",
    projectId: "saasmarketingformula",
    storageBucket: "saasmarketingformula.appspot.com",
    messagingSenderId: "124359787656",
    appId: "1:124359787656:web:1689e9afc61b9cbd15cb3d",
    measurementId: "G-0YB82FXVDY"
  };

  // Initialize Firebase
  firebase.initializeApp(firebaseConfig);
  export const db = firebase.firestore();
  export const functions = firebase.functions();
  export const storage = firebase.storage();

  // db.enablePersistence()
  // .catch(function(err) {
  //     if (err.code == 'failed-precondition') {
  //         // Multiple tabs open, persistence can only be enabled
  //         // in one tab at a a time.
  //         // ...
  //     } else if (err.code == 'unimplemented') {
  //         // The current browser does not support all of the
  //         // features required to enable persistence
  //         // ...
  //     }
  // });

